export const radiuses = {
  4: 4,
  8: 8,
  12: 12
};

export type Radiuses = typeof radiuses;
